import { createContext, use, useMemo, useReducer, type Dispatch, type ReactNode } from 'react'
import { flowReducer, initialFlowState, type FlowEvent, type FlowState } from './machine'

interface FlowContextValue {
  state: FlowState
  dispatch: Dispatch<FlowEvent>
}

const FlowContext = createContext<FlowContextValue | null>(null)

export function FlowProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(flowReducer, initialFlowState)
  // Stable provider value — only changes when `state` changes (dispatch is already stable),
  // so consumers don't re-render on every parent render.
  const value = useMemo(() => ({ state, dispatch }), [state])
  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>
}

export function useFlow(): FlowContextValue {
  const ctx = use(FlowContext)
  if (!ctx) throw new Error('useFlow must be used within a FlowProvider')
  return ctx
}
